import axios from 'axios';
import { BASE_URL, COMPANY_API_PATH } from 'constants/api';
import { accountStore } from 'store/accountStore';
import { FetchResult } from 'type/apiType';
import { CompanyInterface } from 'type/companyType';
import { ApiService } from './apiService';

export class CompanyApiService extends ApiService<CompanyInterface> {
  public async fetch(queryParams?: URLSearchParams): Promise<FetchResult<CompanyInterface>> {
    const platform = accountStore.getAccount()!.platform;
    const paramsObj = Object.fromEntries(queryParams?.entries() || []);
    const response = await axios.get(`${BASE_URL}${COMPANY_API_PATH}`, {
      params: {
        ...paramsObj,
        platform_id: platform.id.toString(),
      },
    });
    return response.data;
  }

  // licensor ID로 company 정보 조회
  public async fetchLicensorById(licensorId: number): Promise<CompanyInterface> {
    const response = await axios.get(`${BASE_URL}${COMPANY_API_PATH}${licensorId}`);
    return response.data;
  }

  public async fetchAllSortedCompanyList(): Promise<CompanyInterface[]> {
    const pageSize = 100;
    const companyList: CompanyInterface[] = [];
    let page = 1;
    let pageNext = true;
    while (pageNext) {
      const queryParams = {
        page_size: pageSize.toString(),
        page: page.toString(),
      };
      const platform = accountStore.getAccount()!.platform;
      const result = await axios.get(`${BASE_URL}${COMPANY_API_PATH}`, {
        params: {
          ...queryParams,
          platform_id: platform.id.toString(),
        },
      });
      pageNext = result.data.next !== null;
      page = page + 1;
      companyList.push(...result.data.results);
    }
    companyList.sort((a, b) => a.id - b.id);
    return companyList;
  }
}

export const companyApiService = new CompanyApiService(COMPANY_API_PATH);
